import { Grid, useEventCallback } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { useFormikContext } from 'formik';
import { DatePicker } from '@mui/lab';
import { useUserProfile } from 'shell/hooks/use-user-profile';
import ServiceList from 'front-office/components/cash-management/shared/service-list';
import { Service } from 'shell/models/service';
import OperatorList from 'front-office/components/shared/operator-list';
import { useCallback } from 'react';
import { FiltersFormTableElectoralCard } from 'front-office/view-models/electoral-card';

const FormFilter = (): React.ReactElement => {
  const formContext = useFormikContext<FiltersFormTableElectoralCard>();

  const { userProfile } = useUserProfile();

  const codeControlloCassa = userProfile.datiLogin?.profile?.feature?.controlloDiCassa || '';

  const onChangeServiceList = useEventCallback((service: Service | Service[], value?: string) => {
    if (!Array.isArray(service)) {
      formContext.setFieldValue('service', service.key.codiceServizio);
      return;
    }
    formContext.setFieldValue('service', value);
  });

  const handleChangeOperator = useCallback(
    (value) => {
      formContext.setFieldValue('operator', value);
    },
    [formContext.setFieldValue]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={5}>
        {codeControlloCassa === '0' || codeControlloCassa === '1' || !codeControlloCassa ? (
          <PmiTextField
            label="Servizio"
            aria-label="Servizio"
            fullWidth
            id="service"
            value={formContext.values.service || ''}
            disabled
          />
        ) : (
          <ServiceList
            auth={codeControlloCassa === '2'}
            allServices={codeControlloCassa === '2'}
            value={formContext.values.service || ''}
            onChange={onChangeServiceList}
          />
        )}
      </Grid>
      <Grid item xs={12} md={5}>
        {codeControlloCassa === '0' || !codeControlloCassa ? (
          <PmiTextField
            id="operator"
            value={formContext.values.operator || ''}
            disabled
            fullWidth
            label="Operatore"
          />
        ) : (
          <OperatorList
            idService={formContext.values.serviceCode || formContext.values.service || ''}
            value={formContext.values.operator || ''}
            onChange={handleChangeOperator}
          />
        )}
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data dal"
          aria-label="Data dal"
          value={formContext.values.dateFrom || null}
          onChange={(date) => {
            formContext.setFieldValue('dateFrom', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="dateForm"
              {...params}
              fullWidth
              error={formContext.touched.dateFrom && Boolean(formContext.errors.dateFrom)}
              helperText={formContext.errors.dateFrom}
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <DatePicker
          label="Data al"
          aria-label="Data al"
          value={formContext.values.dateTo || null}
          onChange={(date) => {
            formContext.setFieldValue('dateTo', date || null);
          }}
          renderInput={(params) => (
            <PmiTextField
              id="dateForm"
              {...params}
              fullWidth
              error={formContext.touched.dateTo && Boolean(formContext.errors.dateTo)}
              helperText={formContext.errors.dateTo}
            />
          )}
        />
      </Grid>
      <Grid item container spacing={2} xs={12} justifyContent="flex-end" display="flex">
        <Grid item xs={12} md={2}>
          <PmiButton variant="contained" color="secondary" fullWidth type="submit">
            Cerca
          </PmiButton>
        </Grid>
      </Grid>
    </Grid>
  );
};

FormFilter.displayName = 'Form Filter';

export default FormFilter;
